import Lookup from 'src/componentes/select-async';
import PerdaOperacionalList from 'src/paginas/gestao-risco/perda-operacional/PerdaOperacionalListViewModal';

const PerdaOperacionalLookup = ({...rest}) => {

  return (
    <Lookup
      labelKey="nome"
      valueKey="id"
      showSearch={true}
      showNew={false}
      url="/PerdaOperacionalLookup"
      clearable
      showModal={true}
      searchComponent={PerdaOperacionalList}
      {...rest}
    />
  );
};

export default PerdaOperacionalLookup;